<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    size="600_auto"
    :visible.sync="modalVisible"
    :no-padding="true"
    :confirmLoading="loading.confirm"
    @cancel="cancel"
    @confirm="confirm">
    <template #header>
      <span>重算</span>
    </template>
    <template #content>
      <div v-loading="loading.page" class="recalculation-content">
        <gj-alert style="padding: 16px 0 12px 0;" class="gj-mlr20" type="warning" show-icon>
          <template #title>
            <div class="color333">重算将对批次与成本数据重新生成，但不会重算期初数据，请谨慎操作！！！重算具体内容请点击 <gj-link :href="helpUrl"  target="_blank">帮助文档</gj-link> 查看。</div>
          </template>
        </gj-alert>
        <el-form ref="form" :model="formData" label-width="133px" class="gj-mt8" :rules="rules">
          <el-form-item label="重算仓库" prop="warehouseId">
            <gj-select
                v-model="formData.warehouseId"
                width="446px"
                @change="changeWarehouse"
                :clearable="false"
                type="custom">
                <div class="warehouse-option-out">
                  <el-option
                    v-for="item in warehouseOptions"
                    :label="item.warehouseName"
                    :value="item.warehouseId"
                    :key="item.warehouseId"
                    :disabled="item.recalculateFlag"
                    class="warehouse-option">
                    <div class="flex justify-between align-center warehouse-option-item">
                      <div :class="{'color333': !item.recalculateFlag}">{{item.warehouseName}}</div>
                      <div v-if="item.recalculateFlag">重算中</div>
                    </div>
                  </el-option>
                </div>
              </gj-select>
          </el-form-item>
          <el-form-item label="MSKU" prop="radio" :style="{marginBottom: formData.radio === '2'? '5px' : '16px'}">
            <el-radio-group v-model="formData.radio">
              <el-radio label="1">全部</el-radio>
              <el-radio label="2">指定</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="formData.radio === '2'">
            <el-form-item label="" label-width="133px" prop="mskuList">
              <gj-textarea
                class="textarea"
                v-model="formData.mskuList"
                :styles="{ height: '120px', fontSize: '12px', width: '446px' }"
                placeholder="请输入要重算的MSKU，一行一项，回车换行，请勿输入空行"
                @input="textareaInput"
                @blur="textareaBlur">
              </gj-textarea>
            </el-form-item>
          </template>
          <el-form-item prop="date" class="form-date">
            <template #label>
              <span>重算开始时间 <br />（站点时区）</span>
            </template>
            <gj-date-picker
              v-model="formData.date"
              width="446px"
              tooltip="重算开始时间"
              :disabledDate="disabledDate"
            ></gj-date-picker>
            <div class="color999 size12">(选择日期为初始化数据生成日期，选择日期之前有数据将不会变动，以历史数据为准)</div>
          </el-form-item>
          <el-form-item prop="costWay">
            <template #label>
              <span>
                成本取值方式
                <gj-help>
                    <div class="size13 weight600">使用说明</div>
                    <div class="size12 gj-mt10" style="line-height: 16px;">手动重置：仅生成数量，不生成成本，重算后需客户手动重置成本进行维护，适合使用系统时间较短、批次数据较少的客户；</div>
                    <div class="size12 gj-mt10" style="line-height: 16px;">取发货单成本：以货件对应的发货单维护的成本为准，适合走系统供应链，以发货单维护货件发货信息的客户；</div>
                    <div class="size12 gj-mt10" style="line-height: 16px;">取批次最新成本：以当前系统批次维护的最后成本为准，适合已重置过批次成本或补录过批次成本的客户；</div>
                </gj-help>
              </span>
            </template>
            <el-radio-group v-model="formData.costWay">
              <el-radio label="costWay01">手动设置</el-radio>
              <el-radio label="costWay02">取发货单成本</el-radio>
              <el-radio label="costWay03">取批次最新成本</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import { NEW_SELECT_WAREHOUSE } from "../config";
import { modalMixIn, queryMixin, selectionMixin } from "@/minxins";
import { storageCostBatchRecalculate, storageCostBatchWarehouseInitDate, storageCostBatchRecalculateeMskuCheck } from "@/api/finance";
import { convertToDate } from "@/utils/date.util.js"
import {helpUrlBase, helpUrls} from "@/components/tool-group/helpUrl"
import { isMeaningful } from '@/utils/common';
export default {
  name: "Recalculation",
  mixins: [modalMixIn, queryMixin, selectionMixin],
  props: {},
  async created() {
    this.warehouseOptions = await NEW_SELECT_WAREHOUSE()
  },
  data() {
    return {
      nonExistent: null, // 不存在的MSKU
      loading: {
        page: false,
        confirm: false
      },
      formData: {
        warehouseId: null,
        radio: "1",
        date: "",
        mskuList: "",
        costWay: ''
      },
      warehouseOptions: [],
      rules: {
        warehouseId: [ { required: true, message: "请选择重算仓库", trigger: ['blur', 'change'] } ],
        date: [ { required: true, message: "请选择日期", trigger: ['blur', 'change'] } ],
        radio: [ { required: true, message: "请选择MSKU", trigger: ['blur', 'change'] } ],
        mskuList: [{ required: true, message: "请输入需要重算的MSKU", trigger: 'blur' }],
        costWay: [{ required: true, message: "请选择成本取值方式", trigger: ['blur', 'change'] }]
      },
      disabledDate: (time) => {
        let date = convertToDate(time)
        if (new Date(date).getTime() + 24*60*60*1000 > new Date().getTime()) {// 限制今天以后
          return true
        }
        if (this.minDate && new Date(date).getTime() < new Date(this.minDate).getTime()) {// 限制最小输入时间
          return true
        }
        return false
      },
      minDate: "",
      helpUrl: helpUrlBase + helpUrls['batchmanagement']
    };
  },
  methods: {
    validateLonlat (rule, value, callback)  {
      if (!this.formData.mskuList && this.formData.radio === "2") {
        callback(new Error());
        return;
      }
      callback();
    },
    changeRadio(val) {
      if (val === "2") {
        setTimeout(() => {
          document.querySelector(".el-textarea__inner").focus()
        }, 100);
      }
    },
    textareaInput() {
      this.formData.mskuList || (this.nonExistent = null)
    },
    textareaBlur() {
      this.storageCostBatchRecalculateeMskuCheck()
    },
    // 校验msku
    async storageCostBatchRecalculateeMskuCheck() {
      if (!this.formData.mskuList || !this.formData.warehouseId ) return false
      let mskuList = this.formData.mskuList.split("\n").filter(e => e );
      if (mskuList.length == 0 ) {
        this.nonExistent = null
        this.formData.mskuList = ""
        return false
      }
      let params = {
        mskuList,
        warehouseId: this.formData.warehouseId
      }
      this.loading.page = true
      try {
        let data = await storageCostBatchRecalculateeMskuCheck(params)
        this.formData.mskuList =  mskuList.join("\n")
        this.nonExistent = (data || []).join(",")
      } finally {
        this.loading.page = false
      }
    },
    changeWarehouse(ev) {
      if(this.formData.warehouseId){
        this.storageCostBatchRecalculateeMskuCheck()
      }
      this.formData.date = ''
      this.minDate = convertToDate(this.warehouseOptions.find(item => item.warehouseId === ev).warehouseInitDate)
    },
    // 获取仓库可选最小时间
    async storageCostBatchWarehouseInitDate() {
      this.loading.page = true
      try {
        let res = await storageCostBatchWarehouseInitDate(this.formData.warehouseId)
        this.minDate = convertToDate(res)
      } finally {
        this.loading.page = false
      }
    },
    // 确定
    confirm() {
      this.loading.confirm = true
      this.$refs.form.validate((valid) => {
        if (this.formData.radio === "2") {
          if (this.nonExistent) {
            this.$gjMessage.error(`指定中有不存在的MSKU【${this.nonExistent}】`)
            this.loading.confirm = false
            return
          }
          if (!this.formData.mskuList) {
            this.$gjMessage.error("请输入指定MSKU")
            this.loading.confirm = false
            return
          }
        }
        if (valid) {
          const modal = this.$gjCreate('gj-info-modal', {
            props: {
              title: '提示',
              content: `系统将在今晚凌晨根据亚马逊库存报表执行您的批次重算任务，请您耐心等待。系统一旦操作无法暂停任务，确定生成重算任务吗？`,
            },
            on: {
              cancel: () => {
                modal.$gjDestroy();
                this.loading.confirm = false
              },
              confirm: () => {
                modal.$gjDestroy();
                this.storageCostBatchRecalculate();
              },
            },
          });
        } else {
          this.$gjMessage.error("请完善数据");
          this.loading.confirm = false
        }
      });
    },
    // 重算
    storageCostBatchRecalculate() {
      let params = {
        mskuList: this.formData.radio === "2" ? this.formData.mskuList.split("\n") : null,
        recalculateAll: this.formData.radio === "2" ? false : true,
        warehouseId: this.formData.warehouseId,
        recalculateDate: convertToDate(this.formData.date),
        costWay: this.formData.costWay
      }
      storageCostBatchRecalculate(params).then(res => {
        let data = res.data
        if(isMeaningful(data)) {
          this.$gjMessage.success('系统正在重算，请查看右上角任务进度。');
          this.$emit("update");
          this.$gjDestroy();
        }
      }).complete(() => { this.loading.confirm = false })
    }
  },
};
</script>

<style scoped lang="scss">
/deep/.el-dialog {
  // .el-form-item {
  //   margin-bottom: 0px;
  // }
  .el-form-item__label {
    width: 113px;
  }
  .el-form-item__error {
    left: 113px;
  }
  .non-existent {
    textarea {
      border: 1px solid#F56C6C;
    }
  }
  .form-textarea {
    margin-bottom: 16px;
  }
  .form-date {
    .el-form-item__label {
      line-height: 16px;
    }
  }
  .form-tooltip {
    position: absolute;
    padding-left: 113px;
    padding-right: 15px;
    line-height: 14px;
    font-size: 12px;
    color: #F56C6C;
  }
}
.msg {
  padding: 10px;
  margin-bottom: 5px;
  /deep/.el-alert--info {
    background: #edf2fc;
  }
}
  //重置仓库下拉框css
.warehouse-option-out{
  max-height: 240px;
  overflow-y: auto;
  padding-top: 8px;
  .warehouse-option{
    height: 32px;
    padding: 0;
    &:hover{
      background-color: #EDF7FF;
    }
    .warehouse-option-item{
      height: 32px;
      font-size: 12px;
      padding: 0px 16px;
      box-sizing: border-box;
    }
  }
}
</style>
